import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../App.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const LogScreen = () => {
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPrompts = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${API_BASE_URL}/api/prompts/`);
        setPrompts(response.data);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching prompts:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPrompts();
  }, []);

  return (
    <div className="App">
      <header className="header">
        <h1>Prompt Logs</h1>
      </header>
      {error && <div className="error">{error}</div>}
      {loading && <div className="loading">Loading...</div>}
      <div className="prompts-list">
        {prompts.map((prompt, index) => (
          <div key={index} className="prompt-item">
            <p><strong>Generated Question:</strong> {prompt.generated_question}</p>
            <p><strong>Response:</strong> {prompt.gemini_response}</p>
            <p><strong>Prompt Token Usage:</strong> {prompt.prompt_token_usage}</p>
            <p><strong>Response Token Usage:</strong> {prompt.response_token_usage}</p>
            <p><strong>Cost:</strong> ${prompt.cost ? prompt.cost.toFixed(6) : 'N/A'}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogScreen;
